import { createAction } from 'react-async-client';

import {
    SET_WORKSHEET_MASS_LIST_FILTERS,
    SET_WORKSHEET_MASS_LIST_SELECTED,
    SET_WORKSHEET_MASS_LIST_SELECTED_STAGE,
    SET_WORKSHEET_MASS_LIST_SORT,
    SET_WORKSHEET_MASS_LIST_PAGINATION,
    SET_WORKSHEET_MASS_LIST_COLUMN_WIDTH
} from 'constants/actionTypes';

export const setWorksheetMassListFilters = createAction(SET_WORKSHEET_MASS_LIST_FILTERS);
export const setWorksheetMassListSelected = createAction(SET_WORKSHEET_MASS_LIST_SELECTED);
export const setWorksheetMassListSelectedStage = createAction(SET_WORKSHEET_MASS_LIST_SELECTED_STAGE);
export const setWorksheetMassListSort = createAction(SET_WORKSHEET_MASS_LIST_SORT);
export const setWorksheetMassListPagination = createAction(SET_WORKSHEET_MASS_LIST_PAGINATION);
export const setWorksheetMassListColumnWidth = createAction(SET_WORKSHEET_MASS_LIST_COLUMN_WIDTH);
